import DashboardLayout from "../../../lib/components/layouts/dashboard";
import { FC, useContext } from "react";
import { AppContext } from "lib/contexts/app-context";
import { isPatientUser } from "lib/utils/util";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { useNavigate } from "react-router-dom";
import SimpleCard from "lib/components/common/simple-card";
import { Row, Col } from "react-bootstrap";
import SimpleButton from "lib/components/common/simple-button";

interface PatientCheckoutMembershipPackageFailedPage {}

const PatientCheckoutMembershipPackageFailedPage: FC<PatientCheckoutMembershipPackageFailedPage> = ({}) => {
  const { appState } = useContext(AppContext);
  const navigateTo = useNavigate();

  const BreadcrumbItems = [
    {
      label: "Dashboard",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.Dashboard
        : PAGE_ROUTES.ADMIN.Dashboard,
    },
    {
      label: "Booking Failed",
      path: PAGE_ROUTES.PATIENT.MembershipPackage,
    },
  ] as BreadcrumbItem[];

  const handleGoToDashboard = () => {
    navigateTo(PAGE_ROUTES.PATIENT.Dashboard);
  };

  const handleTryAgain = () => {
    navigateTo(PAGE_ROUTES.PATIENT.MembershipPackage);
  };

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <SimpleCard>
        <Row className="text-center">
          <Col>
            <div className="mb-4">
              <i className="fas fa-times-circle text-danger" style={{ fontSize: "4rem" }}></i>
            </div>
            <h2 className="text-danger mb-3">Membership Package Booking Failed</h2>
            <p className="text-muted mb-4">
              We're sorry, but there was an issue processing your membership package booking. 
              Please try again or contact support if the problem persists.
            </p>
            
            <div className="d-flex justify-content-center gap-3">
              <SimpleButton
                onClick={handleGoToDashboard}
                variant="outline-secondary"
                size="lg"
              >
                Go to Dashboard
              </SimpleButton>
              <SimpleButton
                onClick={handleTryAgain}
                variant="primary"
                size="lg"
              >
                Try Again
              </SimpleButton>
            </div>
          </Col>
        </Row>
      </SimpleCard>
    </DashboardLayout>
  );
};

export default PatientCheckoutMembershipPackageFailedPage;
